import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import type { TextEditorTool } from "./TextEditor.types";
import {
  TEXT_EDITOR_TOOLBAR_PLACEMENTS,
  TEXT_EDITOR_TOOLBAR_VARIANTS,
  TEXT_EDITOR_TOOLS,
  TEXT_EDITOR_VARIANTS,
} from "./constants";

const TOOL_NAMES = new Set<string>(TEXT_EDITOR_TOOLS);

export const textEditorDataSchema = z.object({
  name: z.string().optional(),
  value: z.string().optional(),
  variant: z.enum(TEXT_EDITOR_VARIANTS).optional(),
  toolbarVariant: z.enum(TEXT_EDITOR_TOOLBAR_VARIANTS).optional(),
  toolbarPlacement: z.enum(TEXT_EDITOR_TOOLBAR_PLACEMENTS).optional(),
  size: z.enum(SIZES).optional(),
  placeholder: z.string().optional(),
  label: z
    .string()
    .optional()
    .describe("Title shown at the start of the toolbar band."),
  rows: z.coerce.number().int().positive().optional(),
  tools: z
    .string()
    .optional()
    .describe(
      "Comma-separated tool names, in the order the toolbar shows them. An " +
        "empty attribute hides the toolbar. Unknown names are dropped.",
    )
    .transform((value) =>
      value === undefined
        ? undefined
        : (value
            .split(",")
            .map((tool) => tool.trim())
            .filter((tool) => TOOL_NAMES.has(tool)) as TextEditorTool[]),
    ),
  inputId: z
    .string()
    .optional()
    .describe(
      "Id forwarded to the editable area so an external <label for> can " +
        "focus it - not `id`, which stays on the host element for handle " +
        "lookups and would win the label association otherwise.",
    ),
  ariaLabel: z.string().optional(),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  readonly: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type TextEditorDataProps = z.infer<typeof textEditorDataSchema>;
